import { useContext, useEffect, useState } from "react";

import ShopInfoEditTable from "../ShopInfoEditTable";
import { CompanyTitledPage } from "../../TitledPage";


import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import { useLocation, useNavigate } from "react-router-dom";

import { SYSTEM_PATH_COMPANY } from "../../../App";
import { CompanyPartHeader } from "../../../components/PartHeader";
import useInputObject from "../../../hooks/useInputObject";
import {
  searchCustomerInfoList,
  searchShopInfoList,
  updateShopInfo
} from "../../../http/api/CustomerAPI";
import { ScreenStatusContext } from "../../../context/ScreenStatusContext";
import { confirmWhenChanged } from "../../../utils/validation";

const getShopLocationState = (customerId, shopId) => ({
  customerId: customerId,
  shopId: shopId,
});

// 店舗情報編集ページ
export default function ShopInformationEditPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const customerId = location.state.customerId;
  const shopId = location.state.shopId;

  // 取引先情報
  const [customer, setCustomer] = useState({});

  // 更新中をあらわすstate
  const [isUpdating, setUpdating] = useState(false);

  // 画面ステータスをcontextから取得
  const {isChanged} = useContext(ScreenStatusContext);

  // 店舗情報
  const shop = useInputObject({
    shopId: "",
    shopName: "",
    shopNameFurigana: "",
    containerQuantity: "",
    customerId: "",
    address: "",
    tel: "",
    fax: "",
    email: "",
    buyerNo: "",
  });

  //取引先情報を取得
  useEffect(() => {
    GetCustomerInfo();
  }, []);
  async function GetCustomerInfo() {
    let response = await searchCustomerInfoList({ customerId });
    setCustomer(response.listCustomerInfo[0]);
  }

  //店舗情報を取得
  useEffect(() => {
    GetShopInfo();
  }, []);
  async function GetShopInfo() {
    let response = await searchShopInfoList({ shopId });
    shop.setValue(response.listShopInfo[0]);
  }

  // 店舗情報を編集
  const updateShopInfoData = async () => {
    setUpdating(true);
    shop.Value.updatedId = 1; //JWTを追加した後削除
    await updateShopInfo(shop.Value);
    alert(`${shop.Value.customerName} ${shop.Value.shopName} 店様の情報を編集しました。"`);
    moveShopInfo();
  };

  // 店舗情報表示画面に移動する
  const moveShopInfo = () => {
    navigate(SYSTEM_PATH_COMPANY + "/shop_information", {
      state: getShopLocationState(customerId, shopId),
    });
  };

  // 店舗情報表示画面に戻る
  const onClickReturnShopInfo = (event) => {
    if (confirmWhenChanged(isChanged)) {
      moveShopInfo();
    }
  };

  // 店舗情報を編集クリック
  const onClickUpdate = (event) => {
    updateShopInfoData();
  };

  return (
    <CompanyTitledPage title="店舗情報編集">
      <Grid container spacing={2}>
        <Grid item xs="auto">
          <Typography>取引先ID : {customer.customerName}</Typography>
        </Grid>
        <Grid item xs="auto">
          <Typography>店舗ID : {shop.Value.shopId}</Typography>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs="auto">
          {/* 取引先名 */}
          <Typography fontWeight="bold" fontSize={30}>
            {customer.customerName}
          </Typography>
        </Grid>
        <Grid item xs>
          {/* 店舗名 */}
          <Typography fontWeight="bold" fontSize={30}>
            {shop.shopName}
          </Typography>
        </Grid>
      </Grid>

      <CompanyPartHeader>
        <Grid container spacing={1}>
          <Grid item xs>
            <Typography fontWeight="bold" fontSize={20}>
              店舗情報の編集
            </Typography>
          </Grid>
          <Grid item xs="auto">
            <Button variant="contained" onClick={onClickUpdate} disabled={isUpdating}>
              更新
            </Button>
          </Grid>
          <Grid item xs="auto">
            <Button variant="outlined" onClick={onClickReturnShopInfo}>
              戻る
            </Button>
          </Grid>
        </Grid>
      </CompanyPartHeader>

      <ShopInfoEditTable shop={shop} customerName={customer.customerName} />
    </CompanyTitledPage>
  );
}
